import React from 'react';
import { Row, Col } from 'antd';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';
import AdjustMeterReadingCommand from './components/AdjustMeterReadingCommand';

const AdjustMeterReading = () => {
  const { command } = usePermission();

  if (!command.setMeterReading) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[
            { name: 'Thiết bị & Cấu hình', path: '/devices' },
            { name: 'Hiệu chỉnh chỉ số', path: '/device/adjust-meter-reading' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <AdjustMeterReadingCommand />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default AdjustMeterReading;
